import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";

import { PageScrollModule } from "@bca-core/modules/page-scroll/page-scroll.module";
import { provideAppConfiguration } from "@bca-core/providers/app-configuration.provider";
import { provideErrorHandler } from "@bca-core/providers/error-handler.provider";
import { provideI18n } from "@bca-core/providers/i18n.provider";
import { provideInterceptors } from "@bca-core/providers/interceptors.provider";
import { provideSentryLogger } from "@bca-core/providers/sentry-logger.provider";
import { SharedModule } from "@bca-shared/shared.module";
import { StoreModule } from "@bca-store/store.module";

import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { DialogModule } from "@bca-core/modules/dialog/dialog.module";
import { BcaFlowModule } from "@bca-flow/bca-flow-window.module";
import { AvoConfiguration } from "@bca-shared/utils/avo/avo-configuration.model";
import { AppRoutingModule } from "@bca/app-routing.module";
import { AppComponent } from "@bca/app.component";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { TranslateModule } from "@ngx-translate/core";
import { environment } from "./../environments/environment";

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    BrowserModule,
    PageScrollModule,
    DialogModule,
    BcaFlowModule,
    StoreModule,
    // Instrumentation must be imported after importing StoreModule (config is optional)
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
    }),
    SharedModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: provideI18n(),
    }),
  ],
  providers: [
    { provide: AvoConfiguration, useValue: AvoConfiguration },
    provideAppConfiguration(),
    provideErrorHandler(),
    provideSentryLogger(),
    provideInterceptors(),
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
